export default __webpack_public_path__ + "static/media/Facebook.dab003fd.svg";